// Msg #800 enhancement — Personal "Adventure Soundtrack" playlist.
// Persisted in localStorage; each item = { npc, music_html, saved_at }.
// Consumed by the floating <AdventureSoundtrackPlayer /> that mounts on
// ChatPage and auto-plays the music of whichever saved NPC is currently
// present in the user's room.

const STORAGE_KEY = 'mandala_soundtrack_v1';

const _read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
};

const _write = (list) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  catch { /* quota / disabled — ignore */ }
};

export const getSoundtrack = () => _read();

export const addToSoundtrack = (npc, musicHtml) => {
  if (!npc || !musicHtml) return false;
  const list = _read().filter((t) => t.npc !== npc);
  list.unshift({ npc, music_html: musicHtml, saved_at: Date.now() });
  _write(list.slice(0, 40));
  window.dispatchEvent(new CustomEvent('mandala:soundtrack-change'));
  return true;
};

export const removeFromSoundtrack = (npc) => {
  const before = _read();
  const after = before.filter((t) => t.npc !== npc);
  if (after.length !== before.length) {
    _write(after);
    window.dispatchEvent(new CustomEvent('mandala:soundtrack-change'));
    return true;
  }
  return false;
};

export const isInSoundtrack = (npc) => _read().some((t) => t.npc === npc);

// Convenience: subscribe to changes across tabs + in-app.
export const onSoundtrackChange = (cb) => {
  const handler = () => cb(_read());
  const storageHandler = (e) => {
    if (e.key === STORAGE_KEY) cb(_read());
  };
  window.addEventListener('mandala:soundtrack-change', handler);
  window.addEventListener('storage', storageHandler);
  return () => {
    window.removeEventListener('mandala:soundtrack-change', handler);
    window.removeEventListener('storage', storageHandler);
  };
};
